(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-page"]) return;
  try {
    
  (() => {
    const styleId = 'tric-growave-loyalty-colors';
    const growaveStyles = `
      :host {
        --gw-color-primary: #5b5a18;
        --gw-color-secondary: #b9bb58;
      }

      .gw-rd-navbar,
      .gw-rd-navbar__inner {
        background: #5b5a18 !important;
      }

      .gw-btn--mode-primary {
        border-color: #5b5a18 !important;
        background: #5b5a18 !important;
        color: #ffffff !important;
      }

      .gw-btn--mode-primary:hover,
      .gw-btn--mode-primary:focus-visible {
        border-color: #682412 !important;
        background: #682412 !important;
      }

      .gw-btn--mode-link,
      .gw-rd-points-program-card__btn {
        color: #682412 !important;
      }

      .gw-rd-points-program-card {
        border-color: rgba(104, 36, 18, 0.22) !important;
        background: #f8f5ed !important;
      }

      a,
      button {
        accent-color: #5b5a18;
      }
    `;

    const applyGrowaveColors = () => {
      let styled = false;

      document.querySelectorAll('.tric-loyalty-hub .gw-rd-popup-root-widget-placeholder').forEach((host) => {
        const root = host.shadowRoot;

        if (!root) return;

        if (!root.getElementById(styleId)) {
          const style = document.createElement('style');
          style.id = styleId;
          style.textContent = growaveStyles;
          root.appendChild(style);
        }

        styled = true;
      });

      return styled;
    };

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;

      if (applyGrowaveColors() || attempts >= 40) {
        window.clearInterval(timer);
      }
    }, 250);

    document.addEventListener('shopify:section:load', applyGrowaveColors);
  })();

  } catch(e) { console.error(e); }
})();
})();
